
export class ScanTicketResponseDto {
  valid: boolean;
  ticketName?: string;
}
